export const AUTH_ENDPOINTS = {
  LOGIN_WITH_PASSWORD: '/admin/auth/login-with-password',
  VERIFY_TOTP: '/admin/auth/verify-totp',
  TOTP_RECONFIGURE: '/admin/me/totp/reconfigure',
  TOTP_CONFIRM: '/admin/me/totp/confirm',

  LOGOUT: '/admin/auth/logout',
  REFRESH: '/admin/auth/refresh-token',
  ME: '/admin/me',
} as const

export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
} as const

export const TOKEN_EXPIRY = {
  ACCESS_TOKEN: 15 * 60 * 1000, // 15 minutes
  REFRESH_TOKEN: 7 * 24 * 60 * 60 * 1000, // 7 days
} as const

// Error codes from API
export const AUTH_ERROR_CODES = {
  INVALID_USERNAME_OR_PASSWORD: 'INVALID_USERNAME_OR_PASSWORD',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  ADMIN_NOT_FOUND: 'ADMIN_NOT_FOUND',
  INVALID_TOKEN: 'INVALID_TOKEN',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INVALID_TOTP: 'INVALID_TOTP',
  TOTP_DISABLED: 'TOTP_DISABLED',
  MFA_TOKEN_INVALID: 'MFA_TOKEN_INVALID',
  MFA_TOKEN_EXPIRED: 'MFA_TOKEN_EXPIRED',
} as const

// Vietnamese error messages mapping
export const AUTH_ERROR_MESSAGES: Record<string, string> = {
  [AUTH_ERROR_CODES.INVALID_USERNAME_OR_PASSWORD]: 'Tên đăng nhập hoặc mật khẩu không đúng',
  [AUTH_ERROR_CODES.ACCOUNT_LOCKED]: 'Tài khoản bị khóa do đăng nhập sai quá nhiều lần. Vui lòng thử lại sau 60 phút',
  [AUTH_ERROR_CODES.ACCOUNT_DISABLED]: 'Tài khoản đã bị vô hiệu hóa. Vui lòng liên hệ quản trị viên',
  [AUTH_ERROR_CODES.TOO_MANY_REQUESTS]: 'Bạn thao tác quá nhanh, vui lòng thử lại sau',
  [AUTH_ERROR_CODES.ADMIN_NOT_FOUND]: 'Không tìm thấy tài khoản. Vui lòng kiểm tra lại tên đăng nhập',
  [AUTH_ERROR_CODES.INVALID_TOKEN]: 'Phiên đăng nhập không hợp lệ. Vui lòng đăng nhập lại',
  [AUTH_ERROR_CODES.VALIDATION_ERROR]: 'Dữ liệu không hợp lệ. Vui lòng kiểm tra lại',
  [AUTH_ERROR_CODES.INVALID_TOTP]: 'Mã xác thực không đúng',
  [AUTH_ERROR_CODES.TOTP_DISABLED]: 'Xác thực hai lớp đang tắt ở môi trường này',
  [AUTH_ERROR_CODES.MFA_TOKEN_INVALID]: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại',
  [AUTH_ERROR_CODES.MFA_TOKEN_EXPIRED]: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại',
}
